var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Panel',{attrs:{"size":"small","hide-header":true},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{attrs:{"data-cy":"container-dashboard-graph"}},[_c('line-chart',{attrs:{"chart-data":_vm.chartData,"options":_vm.options}})],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }